import { GAME_COLLECTION_ALL_COUNTRIES } from 'src/constants';
import { compareByAlphabet } from 'src/helpers/sorting';
import type { GameCollectionSegmentTransformed, GetGameCollectionSegmentResponse } from 'src/types/game-collection';

export const transformGetGameCollectionSegmentResponse: (
  res: GetGameCollectionSegmentResponse,
) => GameCollectionSegmentTransformed = (res) =>
  res && !res.values?.length
    ? [{ segmentId: GAME_COLLECTION_ALL_COUNTRIES, segmentName: 'All Countries' }]
    : res?.values
        .sort((a, b) =>
          b.segmentId === GAME_COLLECTION_ALL_COUNTRIES
            ? 1
            : a.segmentId === GAME_COLLECTION_ALL_COUNTRIES
              ? -1
              : compareByAlphabet(a.segmentName, b.segmentName),
        )
        .map(({ segmentId, segmentName }) => ({
          segmentId,
          segmentName: segmentId === GAME_COLLECTION_ALL_COUNTRIES ? 'All Countries' : segmentName,
        }));
